"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useChannelsBan = void 0;
var _lodash = require("lodash");
var _react = require("react");
var _streamChatReact = require("stream-chat-react");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getChannelBanFromChannelMembership = function getChannelBanFromChannelMembership(channel) {
  return _defineProperty({}, channel.id, channel !== null && channel !== void 0 && channel.state.membership.banned ? {
    expiration: channel === null || channel === void 0 ? void 0 : channel.state.membership.ban_expires
  } : undefined);
};
var useChannelsBan = function useChannelsBan() {
  // ban can be tracked by checking channel.state.membership but it is not updated while user is online
  // so need to track it on our own
  var _useChatContext = (0, _streamChatReact.useChatContext)(),
    client = _useChatContext.client,
    activeChannel = _useChatContext.channel;
  var _useState = (0, _react.useState)(_lodash.assign.apply(void 0, _toConsumableArray((0, _lodash.map)(client === null || client === void 0 ? void 0 : client.activeChannels, getChannelBanFromChannelMembership)))),
    _useState2 = _slicedToArray(_useState, 2),
    ban = _useState2[0],
    setBan = _useState2[1];
  (0, _react.useEffect)(function () {
    if (client) {
      var bansFromClientChannels = _lodash.assign.apply(void 0, _toConsumableArray((0, _lodash.map)(client === null || client === void 0 ? void 0 : client.activeChannels, getChannelBanFromChannelMembership)));
      var banDifference = (0, _lodash.pickBy)(bansFromClientChannels, function (channelBan, channelId) {
        return !(0, _lodash.has)(ban, channelId);
      });
      if (!(0, _lodash.isEmpty)(banDifference)) {
        setBan(_objectSpread(_objectSpread({}, ban), banDifference));
      }
    }
    // activeChannel is not used for calculation but need to track it to get valid activeChannels
  }, [ban, client, client === null || client === void 0 ? void 0 : client.activeChannels, activeChannel]);
  var userBannedHandler = (0, _react.useCallback)(function (e) {
    if (e.channel_id && client.user.id === e.user.id) {
      setBan(function (prev) {
        return _objectSpread(_objectSpread({}, prev), _defineProperty({}, e.channel_id, {
          expiration: e.expiration
        }));
      });
    }
  }, [client]);
  var userUnbannedHandler = (0, _react.useCallback)(function (e) {
    if (e.channel_id && client.user.id === e.user.id) {
      setBan(function (prev) {
        return _objectSpread(_objectSpread({}, prev), _defineProperty({}, e.channel_id, null));
      });
    }
  }, [client]);
  (0, _react.useEffect)(function () {
    var clientBanSubscription;
    var clientUnbanSubscription;
    if (client) {
      clientBanSubscription = client === null || client === void 0 ? void 0 : client.on('user.banned', userBannedHandler);
      clientUnbanSubscription = client === null || client === void 0 ? void 0 : client.on('user.unbanned', userUnbannedHandler);
    }
    return function () {
      if (clientBanSubscription) {
        clientBanSubscription.unsubscribe();
      }
      if (clientUnbanSubscription) {
        clientUnbanSubscription.unsubscribe();
      }
    };
  }, [client]);
  return {
    ban: ban
  };
};
exports.useChannelsBan = useChannelsBan;